import styled from 'styled-components'
import DownArrow from "web/assets/images/arrow_bottom_down_downward_navigation_icon.png";

const Container = styled.div`
  .MuiTab-textColorInherit.Mui-selected {
    opacity: 1;
    color: #0a1f30;
    font-weight: 700;
    // font-family: "latobold" !important;
  }
  .MuiBox-root {
    padding: 0;
  }
  .MuiTab-root {
    opacity: 1;
    text-transform: capitalize;
    // font-family: "latomedium";
    padding: 15px !important;
  }
  .MuiAppBar-colorPrimary {
    color: #7a7a7a;
    background-color: #ffffff !important;
    box-shadow: none;
    text-transform: capitalize;
  }
  .MuiTabs-indicator {
    border: solid 2px #2fb5f1;
  }
  .MuiFormGroup-row {
    flex-direction: row;
    height: 30px;
    margin-bottom: 13px;
  }
`;

const SelectWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    select, input {
        background-color: #ffffff;
        padding: 5px;
        border: solid 1px #97979729 !important;
        border-radius: 3px;
        margin: 2px 0;
        font-size: 14px;
        height: 32px;
    };
    label {
        background-color: #ffffff;
        padding: 5px;
        margin: 2px 0;
        font-size: 14px;
    }
    button{
      background: #61b01f;
      min-height: 46px;
      background: linear-gradient(to bottom, #61b01f 0%,#27911b 100%);
      color: white;
      white-space: nowrap;
      border: 0;
      border-radius: 5px;
      padding: 5px 15px;
      margin: 2px;
      cursor: pointer
    }
`
const TableWrapper = styled.div`
    border-radius: 15px;
    border: 1px solid #87cdf1;
    margin-bottom: 20px;
    box-shadow: 0 9px 8px 0 rgb(0 0 0 / 16%);
    overflow-y: auto;
    min-height: calc(100vh - 225px);
    .table thead th {
        vertical-align: top;
    }
`
const ReportTableWrapper = styled.div`
    border-radius: 15px;
    border: 1px solid #87cdf1;
    margin-bottom: 20px;
    box-shadow: 0 9px 8px 0 rgb(0 0 0 / 16%);
    overflow-y: auto;
    min-height: calc(100vh - 150px);
    .table thead th {
        vertical-align: top;
    }
`

const InnerHeader = styled.div`
    min-height: 50px;
    display: flex;
    padding: 0 20px;
    align-items: flex-start;
    border-bottom: solid 1px #97979729;
    padding: 0 20px;
    gap: 10px;
    padding-bottom: 15px;
    flex-wrap: wrap;
`
const SearchWrapper = styled.div`
  display: flex;
  position: relative;
  border-radius: 4.2px;
  overflow: auto;
  max-width: 260px;
  min-width: 200px;
  width: 100%;
  justify-content: end;
  margin: 3px;
  input {
    background: #ffffff;
    border: 1px solid #87cdf1;
    padding: 4px 35px 4px 15px;
    width: 100%;
    border-radius: 4px;
    ::-webkit-input-placeholder {
      /* Edge */
      color: #00000087;
    }
    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #00000087;
    }
    ::placeholder {
      color: #00000087;
    }
  }
  svg {
    position: absolute;
    right: 12px;
    top: 12px;
    color: #525e66;
    font-size:20px
  }
`;

const SelectWrapperMulti = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  .request-type-class{
    min-width: 160px;
    .select__control {
      border: 1px solid #87cdf1;
      height: 44px;
    }
  }
  .custom-date-piker{
    margin-top: 2px;
    max-width: 200px !important;
  }
  .css-yk16xz-control:hover{
    border: 1px solid #87cdf1;
  }
  select,
  input {
    padding: 5px;
    border: solid 1px transparent !important;
    margin: 2px 0;
    font-size: 16px;
    padding: 5px 13px 10px 10px;
    border-radius: 5px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    ::-webkit-input-placeholder {
      /* Edge */
      color: #656565;
    }
    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #656565;
    }

    ::placeholder {
      color: #656565;
    }
  }
  select {
    background-image: url(${DownArrow});
    background-repeat: no-repeat;
    background-position: calc(100% - 10px) 50%;
    padding: 8px 25px 10px 13px;
    border: 1px solid #87cdf1 !important;
  }
  .fQtZNt select, .fQtZNt input{
    border: 1px solid #87cdf1 !important;
    padding: 6px 25px 10px 13px !important;
  }
  label {
    padding: 5px;
    margin: 2px 0 0;
    font-size: 16px;
  }
  *::-webkit-scrollbar-track {
    background: transparent;
  }
  *::-webkit-scrollbar-thumb {
    border-color: none;
  }
  .basic-multi-select {
    margin: 2px 0;
  }
  .select__value-container {
    max-height: 78.38px;
    overflow: auto;
      input {
        padding: 7px 0;
        min-width: auto;
      }
  }
  .select__control {
    border: 1px solid #87cdf1;
  }
  .react-select-2-input {
    padding: 5px 0;
  }
  .file-input-wrapper .MuiFormControl-root{
    height: 45px;
  }
`;
export { Container, SelectWrapper, InnerHeader, TableWrapper, ReportTableWrapper, SearchWrapper, SelectWrapperMulti};